export default __webpack_public_path__ + "static/media/services12.88a3205f.jpg";